import type { PlayLogBatchIngestResponse, PlayLogIngestResponse, PlayLogPayload } from '@/types/player.types'
import { api } from './api'

function normalizePayload(payload: PlayLogPayload): PlayLogPayload {
  if (!payload.guestCampaignId) return payload

  const normalized = { ...payload }
  delete normalized.slotId
  // deprecated alias — kept only for backward compat with queued payloads
  delete normalized.creativeId
  return normalized
}

export const playLogService = {
  ingest: (payload: PlayLogPayload) =>
    api.post('play-logs/ingest', { json: normalizePayload(payload) }).json<PlayLogIngestResponse>(),

  ingestBatch: (payloads: PlayLogPayload[]) =>
    api
      .post('play-logs/ingest-batch', {
        json: {
          items: payloads.map(normalizePayload)
        }
      })
      .json<PlayLogBatchIngestResponse>()
}
